import React from 'react';

const Member = ({
  member,
  blankHeadshot
}) => {
  return (
    <div className="row member-card border-bottom py-3 mx-md-0 ">
      <div className="headshot col-1 p-0">
        <img
          src={blankHeadshot}
          className="avatar border-0 rounded-circle"
          alt="Member headshot"
        />
      </div>
      <div className="col-md-6 col-11 justify-content-between">
        <div>
          <p className="h4 mb-0 mt-4 d-flex align-items-center">
            {member}
          </p>
        </div>
      </div>
    </div>
  );
};

export default Member;
